// extracted by mini-css-extract-plugin
export var externalLink = "_c7-0";
export var internalLinkLabel = "_c7-1";